import React from "react";
import styles from "./styles.module.scss";
import { formatDefaultValueSelect } from "../../../../../utils/mask";

export function FiltrosLeadsEventos({
  filtersSelectedValues,
  filterOptions,
  onDataInicioChange = null,
  onDataFimChange = null,
  onMesChange = null,
  onAnoChange = null,
  onUFChange = null,
  onEventoChange = null,
}) {
  function handleDataInicioChage({ currentTarget }) {
    if (onDataInicioChange) {
      const newValue = currentTarget.value;
      onDataInicioChange(newValue);
    }
  }
  function handleDataFimChage({ currentTarget }) {
    if (onDataFimChange) {
      const newValue = currentTarget.value;
      onDataFimChange(newValue);
    }
  }
  function handleMesChange({ currentTarget }) {
    if (onMesChange) {
      const newValue = currentTarget.value;
      onMesChange(newValue);
    }
  }
  function handleAnoChange({ currentTarget }) {
    if (onAnoChange) {
      const newValue = currentTarget.value;
      onAnoChange(newValue);
    }
  }
  function handleUFChange({ currentTarget }) {
    if (onUFChange) {
      const newValue = currentTarget.value;
      onUFChange(newValue);
    }
  }
  function handleEventoChange({ currentTarget }) {
    if (onEventoChange) {
      const newValue = currentTarget.value;
      onEventoChange(newValue);
    }
  }

  return (
    <div className={styles.big_container}>
      <div className={styles.content_left}>
        <div>
          <div>
            <label htmlFor="nomeEvento">Nome do evento</label>
          </div>
          <select
            value={filtersSelectedValues?.nomesEventos ?? ""}
            className="correct-color"
            onChange={handleEventoChange}
          >
            <option value={null}>Todas</option>
            {filterOptions?.nomesEventos &&
              filterOptions?.nomesEventos
                .sort((a, b) => {
                  return a < b ? -1 : a > b ? 1 : 0;
                })
                .map((evento, idx) => (
                  <option key={idx} value={evento} title={evento}>
                    {evento}
                  </option>
                ))}
          </select>
        </div>

        <div>
          <div>
            <label htmlFor="input-uf">UF</label>
          </div>
          <select
            value={filtersSelectedValues?.ufs ?? ""}
            className="correct-color"
            onChange={handleUFChange}
          >
            <option value={null}>Todas</option>
            {filterOptions?.ufs &&
              filterOptions?.ufs
                .sort((a, b) => {
                  return a?.sigla < b?.sigla ? -1 : a?.sigla > b?.sigla ? 1 : 0;
                })
                .map((uf) => (
                  <option key={uf.id} value={uf.id} title={uf.sigla}>
                    {uf.sigla}
                  </option>
                ))}
          </select>
        </div>

        <div className={styles.data}>
          <div>
            <div>
              <label htmlFor="dataInicio">Data inicial</label>
            </div>
            <input
              disabled={
                filtersSelectedValues?.mes || filtersSelectedValues?.ano
              }
              value={filtersSelectedValues?.dataInicial ?? ""}
              label="22"
              id="dataInicio"
              name="dataInicio"
              type="date"
              max={"9999-12-31"}
              onChange={handleDataInicioChage}
            />
          </div>

          <div>
            <div>
              <label htmlFor="dataFinal">Data final</label>
            </div>
            <input
              disabled={
                filtersSelectedValues?.mes || filtersSelectedValues?.ano
              }
              value={filtersSelectedValues?.dataFinal ?? ""}
              id="dataFinal"
              name="dataFinal"
              type="date"
              max={"9999-12-31"}
              onChange={handleDataFimChage}
            />
          </div>
        </div>

        <div className={styles.data}>
          <div>
            <div>
              <label htmlFor="input-mes">Mês</label>
            </div>
            <select
              id="input-mes"
              disabled={
                filtersSelectedValues?.dataInicial ||
                filtersSelectedValues?.dataFinal
              }
              value={filtersSelectedValues?.mes ?? ""}
              className="correct-color"
              onChange={handleMesChange}
            >
              <option value={""}>Selecione</option>
              {filterOptions?.meses &&
                filterOptions?.meses.map((mes) => (
                  <option key={mes} value={mes}>
                    {formatDefaultValueSelect(mes)}
                  </option>
                ))}
            </select>
          </div>

          <div>
            <div>
              <label htmlFor="input-ano">Ano</label>
            </div>
            <select
              disabled={
                filtersSelectedValues?.dataInicial ||
                filtersSelectedValues?.dataFinal
              }
              className="correct-color"
              value={filtersSelectedValues?.ano ?? ""}
              onChange={handleAnoChange}
            >
              <option value={""}>Selecione</option>
              {filterOptions?.anos &&
                filterOptions?.anos.sort().map((ano) => (
                  <option key={ano} value={ano}>
                    {ano}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
